module.exports = __webpack_public_path__ + "static/media/money_market_conservative.a28d0ca2.svg";